// import PenguinIntro from "./PenguinIntro";

import Outro from './Outro';

export default [Outro];
